<template>
  <div
    class="section-card"
    :class="{ 'section-card--dark': $vuetify.theme.dark }"
  >
    <div class="section-title">Acciones rápidas</div>
    <div class="mb-3">
      <v-autocomplete
        :value="estadoSeleccionado"
        :items="estados"
        item-value="id"
        item-text="nombre"
        label="Cambiar estado"
        clearable
        dense
        outlined
        hide-details
        hide-no-data
        class="mb-2 mt-2"
        @input="$emit('update:estadoSeleccionado', $event)"
      />
      <v-autocomplete
        :value="prioridadSeleccionada"
        :items="prioridades"
        item-value="id"
        item-text="nombre"
        label="Cambiar prioridad"
        clearable
        dense
        outlined
        hide-details
        hide-no-data
        class="mb-2 mt-3"
        @input="$emit('update:prioridadSeleccionada', $event)"
      />
      <v-autocomplete
        :value="subEstadoSeleccionado"
        :items="subEstadosDisponibles"
        item-value="id"
        item-text="nombre"
        label="Cambiar sub-estado"
        clearable
        dense
        outlined
        hide-details
        hide-no-data
        class="subestado-select mt-3"
        @input="$emit('update:subEstadoSeleccionado', $event)"
      />
      <v-btn
        v-if="mostrarBotonGuardar"
        color="primary"
        class="mt-3 mb-2 action-btn"
        small
        :loading="guardando"
        :disabled="!ticket || guardando"
        @click="$emit('guardar-cambios')"
      >
        <v-icon left x-small>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccionesRapidasPostventa',
  props: {
    ticket: { type: Object, default: null },
    estadoSeleccionado: { type: [Number, String], default: null },
    prioridadSeleccionada: { type: [Number, String], default: null },
    subEstadoSeleccionado: { type: [Number, String], default: null },
    estados: { type: Array, default: () => [] },
    prioridades: { type: Array, default: () => [] },
    subEstadosDisponibles: { type: Array, default: () => [] },
    hayCambios: { type: Boolean, default: false },
    guardando: { type: Boolean, default: false },
    mostrarBotonGuardar: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
.section-card {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 12px;
  height: 100%;
  background: var(--v-swalBkg-base);
  background: color-mix(in srgb, var(--v-primary-base) 5%, var(--v-swalBkg-base));
}

.section-card--dark {
  background: var(--v-secondary-base);
  background: color-mix(in srgb, var(--v-primary-base) 14%, var(--v-secondary-base));
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--v-tabText-base);
}

.action-btn {
  min-height: 40px;
  transition: background-color 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
}

.action-btn:focus-visible {
  outline: 2px solid var(--v-info-base);
  outline-offset: 2px;
}
</style>
